export default class AssignShiftPatternViewModel {
    public userIds: string[] | null = null;
    public pattern: number = 0;
    public startingWeek: number = 0;
    public date: Date | null = new Date();
    public hasSelectedAll: boolean = false;
    public teamFilter: number = 0;
}